import * as React from "react";
// semantic
import {Modal} from "semantic-ui-react";

interface IDialogProps {
    open: boolean;
    title?: React.ReactNode;
    actions: Array<React.ReactElement<any>>;
    fullWidth?: boolean;
    children?: React.ReactNode;
    customStyleClassName?: string;
    onRequestClose?(buttonClicked: boolean): void;
    scrolling?: boolean;
}

export const Dialog: React.SFC<IDialogProps> = (props: IDialogProps) => {

    return (
        <Modal
            closeIcon={!!props.onRequestClose}
            onClose={() => props.onRequestClose && props.onRequestClose(true)}
            size={props.fullWidth ? "fullscreen" : undefined}
            open={props.open}
            className={props.customStyleClassName ? props.customStyleClassName: "BaseModal"}
        >
            {props.title && <Modal.Header>{props.title}</Modal.Header>}
            {
                props.children &&
                <Modal.Content scrolling={props.scrolling || false}>
                    {props.children}
                </Modal.Content>
            }
            <Modal.Actions>
                {props.actions}
            </Modal.Actions>
        </Modal>
    );

};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/Dialog.tsx